import React, { useState } from 'react';
import { Heading, Panel, Stack } from 'rsuite';
import PageContent from '@/components/PageContent';
import reportsImage from '@/images/Analytics.svg';
import organizationImage from '@/images/members.svg';
import flexImage from '@/images/flexWorking.svg';
import flexOfficeImage from '@/images/flex-office2.svg';
import remoteImage from '@/images/Home office.svg';
import leaveImage from '@/images/leave1.svg';
import { useTranslation } from 'react-i18next';






// import Joyride from 'react-joyride';

const Page = props => {
  const { selectedFeature } = props;
  const { t } = useTranslation();






  // const [run, setRun] = useState(true);

  // const steps = [
  //   {
  //     target: '#header-modules',
  //     content: 'You can navigate between the different modules here.',
  //     placement: 'bottom'
  //   },
  //   {
  //     target: '.rs-sidenav',
  //     content: 'You can navigate between the different sections here.',
  //     placement: 'right'
  //   }
  // ];

  const images = {
    analytics: reportsImage,

    organizationSettings: organizationImage,

    // flexWorking: flexImage,
    flexOffice: flexOfficeImage,
    remoteWork: remoteImage,
    leave: leaveImage
  };
  const featureTranslations = {
    analytics: t('analytics'),
    organizationSettings: t('organization'),
    flexOffice: t('flexOffice'),
    remoteWork: t('remoteWork'),
    leave: t('leave')
  };
  // useEffect(() => {
  //   const storedFeature = localStorage.getItem('module');

  //   try {
  //     if (storedFeature) {
  //       const parsedFeature = JSON.parse(storedFeature);

  //       console.log('parsedFeature', parsedFeature);
  //       setSelectedFeature(parsedFeature);
  //     }
  //   } catch (error) {
  //     console.error('Error parsing storedFeature:', error);
  //   }
  // }, []);

  return (
    <PageContent
      style={{ background: 'none' }}
      className="board-wrapper"
      showCopyright={false}
      // header={
      //   <>
      //     <h3 className="title">
      //       {' '}
      //       {moment(new Date(), 'ddd DD-MMM-YYYY, hh:mm A').format('A') == 'AM'
      //         ? 'Good morning'
      //         : 'Good afternoon'}{' '}
      //       {user.firstname + ' ' + user.lastname}
      //     </h3>
      //   </>
      // }
    >
      <Stack justifyContent="center" alignItems="center" direction="column">
        <Panel style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <center>
            <Heading level={3}>{`${t('Welcome To')} ${selectedFeature?.label} ${t('panel')}`}</Heading>
          </center>

          <img style={{ marginTop: 10 }} src={images[selectedFeature?.value]} width={500} />
        </Panel>
      </Stack>
      {/* <Joyride
        steps={steps}
        run={run}
        continuous
        // showProgress
        showSkipButton
        styles={{
          options: {
            zIndex: 10000,
            // arrowColor: '#007bff',
            // backgroundColor: '#007bff',
            primaryColor: '#0d47a1'
            // textColor: '#ffffff'
          }
        }}
      /> */}
    </PageContent>
  );
};

export default Page;
